import * as React from "react"
import { FaEnvelope } from "react-icons/fa6"
import { To } from "react-router-dom"
import { Base } from "./Base"
import { Link } from "@allied/react-web/Router"
import { ButtonLink } from "@allied/react-web/Button"
import { Container } from "@allied/react-web/Container"

type FooterProps = {
  children?: React.ReactNode
  logoImage: string
  logoUrl?: To
  logoDescription?: React.ReactNode
  sublogoImage: string
  sublogoUrl?: To
  sublogoDescription?: React.ReactNode
  menuItems?: FooterItem[]
}

type FooterItem = {
  to?: To
  target?: string
  content: React.ReactNode
  hideCrawl?: boolean
  items: MenuItem[]
}

type MenuItem = {
  to: To
  target?: string
  content: React.ReactNode
  hideCrawl?: boolean
}

export function AlliedMarine(props: FooterProps): React.JSX.Element {
  const {
    menuItems = []
  } = props

  return (
    <Base appendClassNames="font-verdana sm:!font-poppins py-6 md:py-16 bg-white border-t-1 border-t-acsm-secondary">
      <Container size="md">
        <div className="grid grid-cols-12 gap-2 xl:gap-4 divide-x-0 lg:divide-x-2 divide-y-2 lg:divide-y-0 divide-black">
          <div className="col-span-12 lg:col-span-5">
            <div className="flex flex-col gap-4 w-fit py-4">
              <div className="flex flex-row justify-start gap-2 xl:gap-6 divide-x-2 divide-black">
                {
                  props.logoUrl ?
                    <Link to={props.logoUrl} className="flex flex-row items-center gap-2 px-2 no-underline text-sm">
                      <img src={props.logoImage} alt="logo" className="w-7 h-12" />
                      {
                        props.logoDescription &&
                        <span className="font-verdana text-xs text-[#231F20] hidden xl:block">{props.logoDescription}</span>
                      }
                    </Link>
                    :
                    <div className="flex flex-row items-center gap-2 px-2">
                      <img src={props.logoImage} alt="logo" className="w-7 h-12" />
                      {
                        props.logoDescription &&
                        <span className="font-verdana text-xs text-[#231F20] hidden xl:block">{props.logoDescription}</span>
                      }
                    </div>
                }
                {
                  props.sublogoUrl ?
                    <Link to={props.sublogoUrl} className="flex flex-row items-end gap-2 pl-4 pr-2 no-underline text-sm">
                      <img src={props.sublogoImage} alt="sublogo" className="w-10 h-12" />
                      {
                        props.sublogoDescription &&
                        <span className="text-xs hidden xl:block">{props.sublogoDescription}</span>
                      }
                    </Link>
                    :
                    <div className="flex flex-row items-end gap-2 pl-4 pr-2">
                      <img src={props.sublogoImage} alt="sublogo" className="w-10 h-12" />
                      {
                        props.sublogoDescription &&
                        <span className="text-xs hidden xl:block">{props.sublogoDescription}</span>
                      }
                    </div>
                }
              </div>
              <div className="w-full">
                <ButtonLink to="mailto:sales@acsmarine.sg" theme="acsm" variant="primary" size="md"
                  appendClassNames="flex flex-row justify-start items-center gap-2 text-xs md:!text-base">
                  <FaEnvelope className="block h-4 w-4" aria-hidden="true" />
                  <span>sales@acsmarine.sg</span>
                </ButtonLink>
              </div>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-7 lg:pl-4 xl:pl-6 2xl:pl-16">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 py-4">
              {
                menuItems.map((menuItem, i: number) => {
                  return (
                    <div key={`footer-menu-${i}`}>
                      {
                        menuItem.to ?
                          <Link to={menuItem.to} target={menuItem.target} hideCrawl={menuItem.hideCrawl}
                            className="block no-underline text-xl text-acsm-red font-bold mb-4">
                            {menuItem.content}
                          </Link>
                          :
                          <p className="block text-xl text-acsm-red font-bold mb-4">
                            {menuItem.content}
                          </p>
                      }
                      <ul className="grid grid-rows-5 grid-flow-col gap-2">
                        {
                          menuItem.items.map((listItem, j: number) => {
                            return (
                              <li key={`footer-item-${j}`}>
                                <Link to={listItem.to} target={listItem.target} hideCrawl={listItem.hideCrawl}
                                  className="block no-underline text-black hover:text-acsm-primary">
                                  {listItem.content}
                                </Link>
                              </li>
                            )
                          })
                        }
                      </ul>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
      </Container>
    </Base>
  )
}
